class ProductTitusframe extends HTMLElement {
  constructor() {
    super();
    
    // check for intersection observer in window
    if ('IntersectionObserver' in window) {
      this.io = new IntersectionObserver(this.observe.bind(this));
      this.io.observe(this);
    } else {
      this.load();
    }
  }

  observe(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.load();
        this.io.unobserve(this);
      }
    });
  }

  load() {
    this.checkConsent().then((consent) => {
      if (!consent) {
        this.remove();
        return;
      }

      const iframe = document.createElement('iframe');
      iframe.setAttribute('src', this.getAttribute('src'));
      iframe.loading = 'lazy';
      iframe.setAttribute('width', this.getAttribute('width'));
      iframe.setAttribute('height', this.getAttribute('height'));
      iframe.setAttribute('frameborder', 0);
      iframe.setAttribute('allow', this.getAttribute('allow'));
      iframe.allowFullscreen = true;

      this.querySelector('.frame-placeholder').appendChild(iframe);
    });
  }

  checkConsent() {
    return new Promise((resolve) => {
      if (window.Shopify.customerPrivacy) {
        resolve(window.Shopify.customerPrivacy.marketingAllowed());
      } else {
        document.addEventListener("visitorConsentCollected", (event) => resolve(event.detail.marketingAllowed));
      }

      setTimeout(() => resolve(false), 10000);
    });
  }
}

customElements.define('product-titusframe', ProductTitusframe);
